<template>
  <el-form ref="form" class="t_center1">
    <ckeditor v-model="form.courseIntroduce"></ckeditor>
    </el-form-item>
    <el-form-item label="英文简介:" v-if="loginOrgCode == 'blcuonline'">
      <ckeditor v-model="form.courseEnglishIntroduce"></ckeditor>
    </el-form-item>
    <el-form-item align="center">
      <el-button @click="prev(2)">上一步</el-button>
      <el-button type="primary" @click="saveAndNext(2)">保存，进入下一步</el-button>
    </el-form-item>
  </el-form>
  
</template>

<script>
  import ckeditor from '@/components/ckeditor/ckeditor.vue';
  
  export default {
    name: 'step2',
    components: {ckeditor},
    props: {
      form: {
        type: Object,
        default: {}
      },
    },
    data() {
      return {
        loginOrgCode: '',
      }
    },
    methods: {
      saveAndNext(val) {

        this.$emit("changeStep","next",val);
        return;
        console.log(this.form);
        let flag = true;
        let url = '/commodityInfo/updateCourseIntroduceByCommodityId';
        if (!this.form.courseIntroduce) {
          this.$message.error('请填写课程简介');
          flag = false;
        }
        this.searchCourseType();

        if (flag) {
          this.https.fetchPost(url, params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == 200) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.searchCourse();
              this.$emit("changeStep","next",val);
            } else {
              this.$message({
                type: 'info',
                message: msg
              });
            }

          }).catch(err => {
                console.log(err);
                this.$message.error('网络错误');
              }
          );

        }
      },
      prev() {
        this.$emit("changeStep","prev","0");
      }
    }
  };
</script>

<style scoped>

</style>